<svg width="30" height="34" viewBox="0 0 30 34" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g>
        <path d="M29.3103 3.85439C29.3744 3.89108 29.4136 3.95974 29.4126 4.03368L29.3065 11.7398C29.3036 11.9467 29.0296 12.0175 28.927 11.8378L22.3416 0.305281C22.239 0.125551 22.4392 -0.0747566 22.6188 0.0279455L29.3103 3.85439Z" fill="#A594F9"/>
        <path d="M7.32275 12.3663L23.801 2.8501L27.463 9.23365L18.3081 14.4942L7.32275 12.3663Z" fill="#A594F9"/>
        <path d="M7.32275 20.829V12.3662L18.3081 14.494L7.32275 20.829Z" fill="#A594F9"/>
        <path d="M18.3105 14.4941V23.0647L7.44287 20.7595L18.3105 14.4941Z" fill="#A594F9"/>
        <path d="M0 25.2498C0 25.141 0.0578968 25.0405 0.151939 24.986L7.44199 20.7593L18.3096 23.0645L0.457027 33.3805C0.253908 33.4979 0 33.3512 0 33.1165V25.2498Z" fill="#A594F9"/>
    </g>
    <defs>
        <clipPath id="clip0_6410_57936">
            <rect width="30" height="33.8462" fill="white"/>
        </clipPath>
    </defs>
</svg>
